export default {
  cycles: [],
  subjects: [],
  competences: [],
  topicsByCompetences: {},
  topics: [],
  countries: [],
  states: [],
  cities: [],
  users: {},
  studentsCycle: [],
  studentsAttendances: [],
  studentsSubjects: [],
  calendars: [],
  pendingNotificationBanner: {
    total: 0,
    unread: 0,
    solved: 0,
    overdue: 0,
    near: 0,
    pending: 0,
    dismissedOverdue: false,
    dismissedNear: false,
    dismissedPending: false,
    lastFetchedAt: 0,
  },
}